import script from "./TempI.vue?vue&type=script&lang=ts&setup=true"
export * from "./TempI.vue?vue&type=script&lang=ts&setup=true"

import "./TempI.vue?vue&type=style&index=0&id=5c1221fc&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c1221fc"]])

export default __exports__